import { map } from 'ramda';
import { createAction } from 'redux-actions';

export default map(createAction);
